/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
    CredentialTypeToJSONTyped,
} from './CredentialType';
import type { PasswordCredentialParams } from './PasswordCredentialParams';
import {
    PasswordCredentialParamsFromJSON,
    PasswordCredentialParamsFromJSONTyped,
    PasswordCredentialParamsToJSON,
    PasswordCredentialParamsToJSONTyped,
} from './PasswordCredentialParams';

/**
 * 
 * @export
 * @interface PasswordCredential
 */
export interface PasswordCredential {
    /**
     * 
     * @type {CredentialType}
     * @memberof PasswordCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {PasswordCredentialParams}
     * @memberof PasswordCredential
     */
    params: PasswordCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof PasswordCredential
     */
    label?: string;
}



/**
 * Check if a given object implements the PasswordCredential interface.
 */
export function instanceOfPasswordCredential(value: object): value is PasswordCredential {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}

export function PasswordCredentialFromJSON(json: any): PasswordCredential {
    return PasswordCredentialFromJSONTyped(json, false);
}

export function PasswordCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordCredential {
    if (json == null) {
        return json;
    }
    return {
        
        'type': CredentialTypeFromJSON(json['type']),
        'params': PasswordCredentialParamsFromJSON(json['params']),
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function PasswordCredentialToJSON(json: any): PasswordCredential {
    return PasswordCredentialToJSONTyped(json, false);
}

export function PasswordCredentialToJSONTyped(value?: PasswordCredential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': CredentialTypeToJSON(value['type']),
        'params': PasswordCredentialParamsToJSON(value['params']),
        'label': value['label'],
    };
}

